import { render, staticRenderFns } from "./HistoryLimitsHolder.vue?vue&type=template&id=f5658338&"
import script from "./HistoryLimitsHolder.vue?vue&type=script&lang=js&"
export * from "./HistoryLimitsHolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports